// apps/admin/src/components/ui/PageSkeleton.tsx

export function PageSkeleton() {
  return (
    <div className="min-h-screen bg-slate-900 p-6 animate-pulse">
      {/* Top bar */}
      <div className="h-8 w-48 bg-slate-700 rounded mb-6" />

      {/* Stats row */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="bg-slate-800 rounded-xl p-4 shadow-sm">
            <div className="h-4 w-24 bg-slate-700 rounded mb-3" />
            <div className="h-8 w-16 bg-slate-600 rounded" />
          </div>
        ))}
      </div>

      {/* Table skeleton */}
      <div className="bg-slate-800 rounded-xl shadow-sm p-4">
        <div className="h-5 w-32 bg-slate-700 rounded mb-4" />
        {[...Array(6)].map((_, i) => (
          <div key={i} className="flex gap-4 py-3 border-b border-slate-700">
            <div className="h-4 w-1/4 bg-slate-700 rounded" />
            <div className="h-4 w-1/4 bg-slate-700 rounded" />
            <div className="h-4 w-1/4 bg-slate-700 rounded" />
            <div className="h-4 w-1/6 bg-slate-600 rounded" />
          </div>
        ))}
      </div>
    </div>
  );
}

// Day 56 complete
